import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const ecomEmailViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map